<section class="field mb-2" [class]="class">
  <label *ngIf="label" class="mb-2">{{ label }}</label>

  <div
    class="px-3 py-5 w-full border-1 border-dashed border-round border-blue-400 bg-blue-50 text-center relative w-full"
    appDnd
    (fileDropped)="uploadFile($event)"
  >
    <section class="h-full flex justify-content-center align-items-center">
      <input
        type="file"
        #fileDropRef
        class="cursor-pointer opacity-0 absolute z-2 w-full h-full top-0 left-0"
        id="fileDropRef"
        multiple
        (change)="uploadFile($event)"
      />
      <div>
        <img src="assets/images/folder.svg" class="mb-2" style="width: 60px" />
        <p class="font-medium">
          Drag files or <span class="text-blue-500">click here</span>
          to upload
        </p>
        <p class="text-gray-400 text-xs mt-1">
          <ng-container *ngFor="let type of fileType">
            {{ type | uppercase }}
          </ng-container>
          up to {{ fileSize }}MB (Max: {{ maxFiles }} files)
        </p>
      </div>
    </section>
  </div>

  <div class="py-3 remove-padding-empty" *ngIf="showImagesPreview">
    <ng-container *ngIf="formControlKey; else elseTemplate">
      <!-- ! Iz diva ispod [sortablejs]="fileList"> -->
      <ng-container *ngFor="let item of fileList; let imgIndex = index">
        <div
          class="mb-2 flex align-items-center justify-content-between border-1 border-transparent border-round p-2 hover:border-gray-100 transition-all transition-duration-300 cursor-pointer"
          [class.hidden]="item?.delete"
        >
          <main class="flex w-full align-items-center">
            <ng-container *ngIf="uploadType === 'image'; else elseTemplate">
              <!-- {{ item.imageLocalUrl }} -->
              <!-- <img
                  class="w-3rem border-round mr-2"
                  [src]="item.imageLocalUrl"
                  alt=" "
                /> -->
              <img
                class="w-3rem border-round mr-2"
                [src]="item.imageLocalUrl | safeUrl"
                alt=" "
              />
            </ng-container>
            <ng-template #elseTemplate>
              <i class="pi pi-file text-2xl mr-2"></i>
            </ng-template>

            <span *ngIf="!includeSeo">{{ item.filename }}</span>
          </main>
          <span
            type="button"
            pTooltip="Delete"
            tooltipPosition="top"
            class="p-1 text-sm text-pink-400"
            (click)="removeFile($event, imgIndex, item.filename)"
          >
            <i class="pi pi-trash"></i>
          </span>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #elseTemplate>
      <!-- ! Iz diva ispod [sortablejs]="fileList" -->
      <ng-container *ngFor="let item of fileList; let imgIndex = index">
        <div
          class="mb-2 flex align-items-center justify-content-between border-1 border-transparent border-round p-2 hover:border-gray-100 transition-all transition-duration-300 cursor-pointer"
          [class.hidden]="item?.delete"
        >
          <main class="flex w-full align-items-center">
            <ng-container *ngIf="uploadType === 'image'; else elseTemplate">
              <img
                class="w-8rem border-round mr-2"
                [src]="item.imageLocalUrl | safeUrl"
                alt=" "
              />
            </ng-container>
            <ng-template #elseTemplate>
              <i class="pi pi-file text-2xl mr-2"></i>
            </ng-template>

            <a
              [href]="item?.url"
              class="text-black-alpha-90"
              target="_blank"
              *ngIf="!includeSeo"
              >{{ item.filename }}</a
            >
          </main>
          <span
            type="button"
            pTooltip="Remove"
            tooltipPosition="top"
            class="p-1 text-sm text-pink-400"
            (click)="removeFile($event, imgIndex, item.filename)"
          >
            <i class="pi pi-trash"></i>
          </span>
        </div>
      </ng-container>
    </ng-template>
  </div>
</section>
<app-help-message
  *ngIf="helpMessage"
  [message]="helpMessage"
></app-help-message>
